<script>
import { QcVersionServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { getLocalStorage } from '@/utils/storage'
const qcvsp = new QcVersionServiceProxy()

export default {
  data() {
    return {
      confirmLoading: false,
      selectedCraft: ''
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    versionList: {
      type: Array,
      default: () => []
    },
    productId: {
      type: String,
      default: ''
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOk() {
      const version = this.versionList.find((res) => res.id === this.selectedCraft)
      if (version) {
        const dto = {
          craftId: version.id,
          craftVersion: version.version,
          productId: this.productId,
          tenantId: getLocalStorage('USER_INFO').tenant_id
        }
        this.confirmLoading = true
        qcvsp
          .createQcVersion(dto)
          .then(() => {
            this.$message.success(this.$t('page_user_management_new_success'))
            this.selectedCraft = ''
            this.confirmLoading = false
            this.$emit('save')
          })
          .catch(() => {
            this.confirmLoading = false
          })
      } else {
        this.$message.warning(this.$t('page_bom_choose_version'))
      }
    },
    handleCancel() {
      this.selectedCraft = ''
      this.$emit('close')
    },
    selectCraft(value) {
      this.selectedCraft = value
    }
  }
}
</script>

<template>
  <a-modal
    :title="$t('page_bom_realte_gybb')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item :label="$t('page_my_document_edition')">
        <a-select :placeholder="$t('page_my_document_edition')" 
        show-search
        :filter-option="filterOption"
        :value="selectedCraft" style="width: 100%" @change="selectCraft">
          <template v-for="(craft, index) in versionList">
            <a-select-option :value="craft.id" :key="index" class="craft-selection">
              {{ craft.version }}
            </a-select-option>
          </template>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<style lang="scss" scoped></style>
